
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'
import { Sorting } from '../helpers/types'

const SIZE_PARAM = 'page_size'
const SORT_PARAM = 'sort_by'

@Component({
  template: `
    <div class="flex" :class='{"hidden-phone hidden-phablet-p": !onPhone, "hidden-desktop hidden-tablet-l": onPhone, "filter__dropdown": addFilterClass}'>
      <dropdown class="subcategory__dropdown mr-1" icon-class="icons8-chevron-down" v-model="isSizeDropdownOpen">
        <template slot="label"> {{ selectedPageSize }} {{ productLabel }} </template>
        <template slot="options">
          <button
            v-for="pageSize in pageSizes"
            :class='{"is-active": selectedPageSize === pageSize}'
            class="dropdown-item"
            @click="selectPageSize(pageSize)"
          >
            {{ pageSize }} {{ productLabel }}
          </button>
        </template>
      </dropdown>
      <dropdown class="subcategory__dropdown" icon-class="icons8-chevron-down" v-model="isSortDropdownOpen">
        <template slot="label">
          {{ selectedSorting.displayname }}
        </template>
        <template slot="options">
          <button
            v-for="sortingName in sortingNames"
            :class='{"is-active": sortingName.displayname === selectedSorting.displayname}'
            class="dropdown-item"
            @click="selectSorting(sortingName)"
          >
            {{ sortingName.displayname }}
          </button>
        </template>
      </dropdown>
    </div>
  `
})
export default class SortAndSizeDropDown extends Mixin {
  @Prop({ default: [{displayname:'Relevance', param: 'priority' }] }) sortingNames: Sorting[]
  @Prop({ default: 'product' }) productLabel: string
  @Prop({ default: false }) onPhone: boolean
  @Prop({ default: false }) addFilterClass: boolean

  isSizeDropdownOpen = false
  isSortDropdownOpen = false
  pageSizes: number[] = [10, 25, 50]

  selectedPageSize = 50
  selectedSorting: Sorting = this.sortingNames[0]

  params = new URLSearchParams()

  selectPageSize(size: number){
    this.selectedPageSize = size
    this.isSizeDropdownOpen = false
    this.resetPagination()
    this.updateParam(SIZE_PARAM, size.toString())

  }

  selectSorting(sorting: Sorting){
    this.selectedSorting = sorting
    this.isSortDropdownOpen = false
    this.resetPagination()
    this.updateParam(SORT_PARAM, sorting.param)
  }

  resetPagination() {
    if(this.params.has('page')) this.params.delete('page')
  }

  createUrl(){
    return window.location.origin + window.location.pathname + '?' + this.params.toString()
  }

  updateParam(key: string, value: string){
    if (this.params.has(key)) {
      this.params.set(key, value)
    }
    else {
      this.params.append(key, value)
    }
    window.location.href = this.createUrl()
  }

  searchSorting(param: string): Sorting | undefined{
    return this.sortingNames.find(item => item.param === param)
  }

  created(): void {
    const uri = window.location.search.replace('?', '')
    this.params =  new URLSearchParams(uri);
    if(this.params.has(SIZE_PARAM)) this.selectedPageSize = Number(this.params.get(SIZE_PARAM))
    if(this.params.has(SORT_PARAM)) {
      const foundSorting = this.searchSorting(this.params.get(SORT_PARAM) as string)
      if(foundSorting) this.selectedSorting = foundSorting
    }
  }

}
